import React, {FocusEventHandler, ReactNode} from "react";

export interface FieldInputProps {
    id: string
    required?: boolean
    label?: string
    value?: string
    invalid?: boolean
    help?: string
    placeholder?: string
    disabled?: boolean
    readonly?: boolean
    maxLength?: number
    inputTransform?: (value: string) => string
    onChange?: (value: string) => void
    onBlur?: FocusEventHandler<any> | undefined
    onInput?: (e: React.FormEvent<HTMLInputElement>) => void
    iconRight?: string
    buttonRight: ReactNode
}

const FieldInputWithButton = function FieldInputWithButton({
                                                               id,
                                                               required,
                                                               label,
                                                               value,
                                                               invalid,
                                                               help,
                                                               placeholder,
                                                               readonly,
                                                               disabled,
                                                               onChange,
                                                               onBlur,
                                                               maxLength,
                                                               onInput,
                                                               inputTransform,
                                                               iconRight,
                                                               buttonRight,
                                                           }: FieldInputProps) {
    const inputId = `${id}-input`

    return <>
        <div className={`field ${required ? 'required' : ''}`}>
            {label && <label className={`label`} htmlFor={inputId}>{label}</label>}
            <div id={id} className={`field  ${buttonRight ? 'has-addons' : ''}`} style={{margin: '0'}}>
                <div className={`control is-expanded ${iconRight ? 'has-icons-right' : ''}`}>
                    <input
                        id={id ? inputId : undefined}
                        className={`input is-fullwidth ${invalid ? 'is-danger' : ''}`}
                        type={"text"}
                        value={value}
                        placeholder={placeholder}
                        readOnly={readonly}
                        disabled={disabled}
                        maxLength={maxLength}
                        onBlur={onBlur}
                        onInput={e => {
                            if (inputTransform) {
                                const input = e.currentTarget;
                                const start = input.selectionStart;
                                const end = input.selectionEnd;
                                const value = input.value
                                const val = inputTransform(value)
                                if (value !== val) {
                                    input.value = val
                                    setTimeout(() => {
                                        input.setSelectionRange(start, end)
                                    }, 1)
                                }
                            }
                            onInput && onInput(e)
                        }}
                        onChange={e => onChange && onChange(e.target.value)}
                    />
                    {iconRight && <span className={"icon is-small is-right"}>
                    <span className="material-symbols-outlined">{iconRight}</span>
                </span>}
                </div>
                <div className={'control'}>
                    {buttonRight}
                </div>
            </div>
            <p className={`help ${invalid ? 'is-danger' : ''}`}>{help}</p>
        </div>
    </>
}

export {
    FieldInputWithButton
}
